var weightNumber = 10000000;
export var updateLeagueRankID = function (league, isFromUserRegion) {
    league.defaultOrder = isFromUserRegion ? league.defaultOrder - weightNumber : league.defaultOrder;
    return league;
};
//# sourceMappingURL=updateLeagueRankID.js.map